import { RECONNECTING_DESCRIPTION } from './AgentStreamToastDescription';

export const AGENT_STREAM_CONTEXT = {
  toast: {
    connection: {
      error: {
        title: 'Real-time connection error',
        description: RECONNECTING_DESCRIPTION,
        customId: 'pingu-connection-error',
      },
      lost: {
        title: 'Real-time connection lost',
        description: RECONNECTING_DESCRIPTION,
        customId: 'pingu-connection-lost',
      },
    },
    validation: {
      error: {
        title: 'Error saving your changes',
        description: 'Please try again',
      },
    },
    network: {
      error: {
        title: 'Error saving your changes',
        description: 'Please try again',
      },
    },
  },
  customIds: {
    connectionError: 'pingu-connection-error',
    connectionLost: 'pingu-connection-lost',
  },
} as const;
